module.exports = __webpack_public_path__ + "img/freestyle_box27.53f705c5.jpg";